module.exports = __webpack_public_path__ + "media/images/flags/BI-5cc3f4ab29884f20200321bd9bdb9fd6.svg";